import { render, staticRenderFns } from "./UsageRestriction.vue?vue&type=template&id=ca61dc40"
import script from "./UsageRestriction.vue?vue&type=script&lang=js"
export * from "./UsageRestriction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports